import { mapApiPaginated } from "@eudonet/opal";
import { searchSubscriptions, getSubscription, createSubscription, updateSubscription, pauseSubscription, resumeSubscription, cancelSubscription, getSubscriptionDonations, } from "../api/subscriptionApi";
import { mapApiSubscriptionToSubscription } from "../mappers/subscriptionMapper";
import { mapApiDonationToDonation } from "../mappers/donationMapper";
export async function getSubscriptions(options) {
    const apiResponse = await searchSubscriptions({
        donorId: options?.donorId,
        contactId: options?.contactId,
        organizationId: options?.organizationId,
        status: options?.status,
        frequency: options?.frequency,
        page: options?.page,
        perPage: options?.pageSize,
        sortBy: options?.sortBy,
        sortOrder: options?.sortOrder,
    });
    return mapApiPaginated(apiResponse, mapApiSubscriptionToSubscription);
}
export async function fetchSubscription(subscriptionId) {
    const apiSubscription = await getSubscription(subscriptionId);
    return mapApiSubscriptionToSubscription(apiSubscription);
}
export async function saveSubscription(payload) {
    const apiSubscription = await createSubscription(payload);
    return mapApiSubscriptionToSubscription(apiSubscription);
}
export async function editSubscription(subscriptionId, payload) {
    const apiSubscription = await updateSubscription(subscriptionId, payload);
    return mapApiSubscriptionToSubscription(apiSubscription);
}
export async function pauseSubscriptionAction(subscriptionId) {
    const apiSubscription = await pauseSubscription(subscriptionId);
    return mapApiSubscriptionToSubscription(apiSubscription);
}
export async function resumeSubscriptionAction(subscriptionId) {
    const apiSubscription = await resumeSubscription(subscriptionId);
    return mapApiSubscriptionToSubscription(apiSubscription);
}
export async function cancelSubscriptionAction(subscriptionId) {
    const apiSubscription = await cancelSubscription(subscriptionId);
    return mapApiSubscriptionToSubscription(apiSubscription);
}
export async function fetchSubscriptionDonations(subscriptionId, options) {
    const apiResponse = await getSubscriptionDonations(subscriptionId, {
        page: options?.page,
        perPage: options?.pageSize,
    });
    return mapApiPaginated(apiResponse, mapApiDonationToDonation);
}
